import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { SalesDashboardRoutingModule } from './sale-dashboard-routing.module';
import { SalesDashboardComponent } from './sales-dashboard/sales-dashboard.component';
import { SalesPersonProductionDashboardComponent } from './sales-person-dashboard/sales-person-production-dashboard/sales-person-production-dashboard/sales-person-production-dashboard.component';
import { SalesPersonDashboardSubheaderComponent } from './sales-person-dashboard/sales-person-dashboard-subheader/sales-person-dashboard-subheader.component';
import { SalesPersonProductionDashboardChartComponent } from './sales-person-dashboard/sales-person-production-dashboard/sales-person-production-dashboard-chart/sales-person-production-dashboard-chart.component';
import { SalesPersonCommissionsDashboardComponent } from './sales-person-dashboard/sales-person-commissions-dashboard/sales-person-commissions-dashboard/sales-person-commissions-dashboard.component';
import { SalesComparisonDashboardComponent } from './sales-comparison-dashboard/sales-comparison-dashboard.component';
import { TelephonyComparisonCallsDashboardComponent } from './telephony-comparison-calls/telephony-comparison-calls-dashboard.component';
import { TelephonyComparisonCallsSubheaderComponent } from './telephony-comparison-calls/telephony-comparison-calls-subheader/telephony-comparison-calls-subheader.component';
import { SalesComparisonMarketingDashboardComponent } from './sales-comparison-marketing/sales-comparison-marketing-dashboard.component';
import { SalesComparisonMarketingSubheaderComponent } from './sales-comparison-marketing/sales-comparison-marketing-subheader/sales-comparison-marketing-subheader.component';
import { TotalCountPipe } from 'src/app/shared/components/dashboard-subheader/total-count.pipe';

@NgModule({
  declarations: [
    SalesDashboardComponent,
    SalesPersonProductionDashboardComponent,
    SalesPersonDashboardSubheaderComponent,
    SalesPersonProductionDashboardChartComponent,
    SalesPersonCommissionsDashboardComponent,
    SalesComparisonDashboardComponent,
    TelephonyComparisonCallsDashboardComponent,
    TelephonyComparisonCallsSubheaderComponent,
    SalesComparisonMarketingDashboardComponent,
    SalesComparisonMarketingSubheaderComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SalesDashboardRoutingModule,
    TotalCountPipe,
  ],
})
export class SalesDashboardModule {}
